<template>
	<div class="gmapMain">
		<gmap-map class="gmapDisplay" ref="map" :center="mCenter" :zoom="mZoom">
			<gmap-marker v-for="(m, mI) in mMarker" :key="(m + mI)" :position="m.position" :icon="m.icon" :label="m.label"
				:opacity="m.opacity" :visible="m.visible"
				:clickable="mOptions.clickable" :draggable="mOptions.draggable"
				@click="mClick(m)" @drag="mDrag" @dragstart="mDragstart" @dragend="mDragend"></gmap-marker>
			
			<gmap-info-window :position="infoPos" :opened="infoShow" :options="infoOptions" @closeclick="infoShow = !infoShow">
				<div class="infoMain">
					<div class="infoRow" v-for="i in infoContent" :key="i">
						<div class="infoTitle" v-if="i['type'] == 'string'" :style="i['css']">{{i['title']}}</div>
						<div class="infoValue" v-if="i['type'] == 'string'" :style="i['css']">{{i['value']}}</div>
						<div class="infoBtnMain" v-if="i['type'] == 'button'">
							<button class="infoBtn" @click="infoBtnClick(i['title'])">{{i['title']}}</button>
						</div>
					</div>
				</div>
			</gmap-info-window>
		</gmap-map>
	</div>
</template>

<script>
/* eslint-disable */
var directionService;
var directionRenderer;
var directionRendererTwo;
var service;
var map;

//Fixed Variables
const defaultpos = { lat: 3.091033, lng: 101.403 };
const defaultzoom = 8;

export default {
	name: 'gmap',
	components: {
	},
	props: {
		//-------- Map Props
		mLoaded: { type: Boolean, default: false }, //This is a boolean to show if google map has been loaded (some functions will return google not defined if this hasn't loaded)
		mCenter: { type: Object, default: function () { return defaultpos; } },
		mZoom: { type: Number, default: defaultzoom },
		mOptions: { type: Object, default: function () { return { }; } },
		mMarker: { type: Array, default: function () { return []; } },
		mDirections: { type: Object, default: function () { return { fromlat: 0, fromlng: 0, tolat: 0, tolng: 0 }; } },
		mMetric: { type:String, default: 'time' },

		//-------- Info Window Props
		infoMarker: { type: Object, default: function () { return {}; } },
		infoPos: { type: Object, default: function () { return {}; } },
		infoShow: { Boolean, default: false },
		infoContent: { type: Object, default: function () { return {}; } },
		infoOptions: { type: Object, default: function () { return { pixelOffset: { width: 0, height: -50 } }; } },
	},
	data() {
		return {
			shortestDurationIndex: 0,
			shortestDistanceIndex: 0,
		}
	},
	mounted() {
		this.$gmapApiPromiseLazy().then(() => {
			map = this.$refs.map.$mapObject;
			directionService = new google.maps.DirectionsService();
			directionRenderer = new google.maps.DirectionsRenderer();
			directionRendererTwo = new google.maps.DirectionsRenderer();
			service = new google.maps.places.PlacesService(map);
			this.mLoaded = true;
		});
	},
	methods: {
		//-------- Map Methods
		mSetRoute: function(r) {
			if (this.mLoaded) {
				//console.log(r['fromlat'] + ' | ' + r['fromlng'] + ' | ' + r['tolat'] + ' | ' + r['tolng']);
				if (r['fromlat'] == 0 || r['fromlng'] == 0 || r['tolat'] == 0 || r['tolng'] == 0) {
					directionRenderer.setDirections({ routes: [] });
					this.mCenter = defaultpos; this.mZoom = defaultzoom;
				} else {
					directionRenderer.setMap(map);
					var mRequest = {
						origin: { lat: parseFloat(r['fromlat']), lng: parseFloat(r['fromlng']) },
						destination: { lat: parseFloat(r['tolat']), lng: parseFloat(r['tolng']) },
						travelMode: "DRIVING",
						provideRouteAlternatives: true, 
					};
					directionService.route(mRequest, (response, status) => {
						console.log(response);
						if (status == "OK") {
							for (let i = 0; i < response.routes.length; i++) {
								if (response.routes[i]["legs"][0]["distance"]["value"] < response.routes[this.shortestDistanceIndex]["legs"][0]["distance"]["value"])
									this.shortestDistanceIndex = i;
								if (response.routes[i]["legs"][0]["duration"]["value"] < response.routes[this.shortestDurationIndex]["legs"][0]["duration"]["value"])
									this.shortestDurationIndex = i;
							}
							directionRenderer.setDirections(response);
						}
						else { console.log('[GMAP] ' + status); }
					});
				}
			}
		},
		//-------- Marker Methods
		mClick: function (m) {
			this.$emit("click", m);
			this.infoMarker = m;
			this.infoPos = m['position'];
			this.infoContent = m['info'];
			this.infoShow = true;
		},
		
		//-------- Places Search Methods
		mSearch: function(location) {
			const request = {
				query: location, 
				fields: ["name", "geometry"],
			}
			service.findPlaceFromQuery(request, (results, status) => {
				if (status === google.maps.places.PlacesServiceStatus.OK && results) {
					for (let i = 0; i < results.length; i++) {
						console.log(results[i]);
						console.log(results[i]["geometry"]["location"].lat());
						console.log(results[i]["geometry"]["location"].lng());
						this.mMarker.push()
					}
				}
			}) 
		},

		//-------- Select Route Methods
		mSelectRoute: function(r) {
			if (r === 'time') {
				directionRenderer.setRouteIndex(this.shortestDurationIndex);
			}
			else if (r === 'distance') {
				directionRenderer.setRouteIndex(this.shortestDistanceIndex);
			}
		},

		//-------- Set Journey Methods
		mSetJourney: function(locations, options) {
			var waypoints = [];
			if (locations === null) {
				directionRenderer.setMap(null);
				return
			}
			
			for (let i = 1; i < locations.length - 1; i++) {
				waypoints.push({
					location: new google.maps.LatLng(locations[i]['lat'], locations[i]['lng']), 
				});
			}

			var service_options = {
				origin: new google.maps.LatLng(locations[0]['lat'], locations[0]['lng']),
				destination: new google.maps.LatLng(locations[locations.length - 1]['lat'], locations[locations.length - 1]['lng']),
				travelMode: 'DRIVING'
			}

			if (waypoints.length > 0) 
				service_options['waypoints'] =  waypoints;

			directionRenderer.setOptions({
				polylineOptions: {
					strokeColor: '#26B900',
					strokeWeight: 6,
					zIndex: 2,
				}
			});
			
			directionService.route(service_options, (response, status) => {
				console.log('directionService 1');
				console.log(response);
				directionRenderer.setMap(null);
				if (status == "OK") {
					this.$emit('directions', response); 
					directionRenderer.setMap(map);	
					directionRenderer.setDirections(response);
				}
				else { 
					this.$emit('directions', null);
					console.log('[GMAP] ' + status); 
				}
			});

			var service_optionsTwo = {
				origin: new google.maps.LatLng(locations[0]['lat'], locations[0]['lng']),
				destination: new google.maps.LatLng(locations[locations.length - 1]['lat'], locations[locations.length - 1]['lng']),
				travelMode: 'DRIVING'
			}

			if (waypoints.length > 0) 
				service_optionsTwo['waypoints'] =  waypoints;

			service_optionsTwo['optimizeWaypoints'] = true;

			directionRendererTwo.setOptions({
				polylineOptions: {
					strokeColor: 'deepskyblue',
					strokeWeight: 4,
					zIndex: 1,
				}
			});

			directionService.route(service_optionsTwo, (response, status) => {
				console.log('directionService 2')
				console.log(response);
				directionRendererTwo.setMap(null);
				if (status == "OK") {
					this.$emit('optimizedDirections', response);
					directionRendererTwo.setMap(map);	
					directionRendererTwo.setDirections(response);
				}
				else { 
					console.log('[GMAP] ' + status); 
				}
			});
		},
		mRenderRoute: function (index) {
			console.log("GMAPV2 - mRenderRoute");
			if (index === 0) {
				console.log('mRenderRotue - IF');
				directionRenderer.setMap(null);
				directionRenderer.setOptions({
					polylineOptions: {
						strokeColor: '#26B900',
						strokeWeight: 6,
						zIndex: 2,
					}
				});
				directionRenderer.setMap(map);
				directionRendererTwo.setMap(null);
				directionRendererTwo.setOptions({
					polylineOptions: {
						strokeColor: 'deepskyblue',
						strokeWeight: 4, 
						zIndex: 1,
					}
				});
				directionRendererTwo.setMap(map);
			}
			else if (index === 1) {
				console.log('mRenderRoute - ELSE'); 
				directionRenderer.setMap(null);
				directionRenderer.setOptions({
					polylineOptions: {
						strokeColor: '#26B900',
						strokeWeight: 4,
						zIndex: 1, 
					}
				});
				directionRenderer.setMap(map);
				directionRendererTwo.setMap(null);
				directionRendererTwo.setOptions({
					polylineOptions: {
						strokeColor: 'deepskyblue',
						strokeWeight: 6, 
						zIndex: 2,
					}
				});
				directionRendererTwo.setMap(map);
			}
		},

		mDrag: function (m) {
				this.$emit("drag", m);
		},
		mDragstart: function (m) {
				this.$emit("dragstart", m);
		},
		mDragend: function (m) {
				this.$emit("dragend", m);
		},

		//-------- Info Window Methods
		infoBtnClick: function (title) {
				this.$emit("infoBtnClick", title, this.infoMarker);
		},
	},
	watch: {
		mMarker: { deep: true, handler(r) { this.infoContent = ''; this.infoShow = false; } },
		mDirections: { deep: true, handler(r) { this.mSetRoute(r); } },
		mMetric: { deep: true, handler(r) { this.mSelectRoute(r); } }
	},
};
</script>

<style lang="scss">
@import "@/css/all.scss";
	
.gmapMain {
	width: 100%;
	height: 100%;
	position: relative;
}

.gmapDisplay {
	width: 100%;
	height: 100%;
	position:  absolute;
}

.infoMain {
	width: 100%;
	min-width: 300px;
	height: 100%;
	margin: 0 20px 0 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
}

.infoRow {
	width: 100%;
	height: auto;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
}

.infoTitle {
	width: 100px;
	height: auto;
	margin: 0 20px 0 0;
	font-size: 11px;
	font-weight: bold;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	white-space: nowrap;
}

.infoValue {
	width: auto;
	height: auto;
	font-size: 11px;
	text-align: left;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	white-space: pre-wrap;
}

.infoBtnMain {
	width: 100%;
	height: 24px;
	margin: 5px 0 0 0;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.infoBtn {
	width: 160px;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>